/* global $ */

class Blog
{
    constructor () 
    {
        this.blogfilter();
        this.blogLoadMore();
        console.log("blog Initiated");
    }

    blogfilter()
    {
        $('.category-select').on('change', function(){
            $('#blog-search').submit();
        });
        $('.blog-search').on('click', function(){
            $('#blog-search').submit();
        });
    }


    blogSearch(url, value, text)
    {
        if(value == '' && text == '') {
            window.location.href = url;
        }
        var queryParams = new URLSearchParams(window.location.search);
        // Set new or modify existing parameter value. 
        queryParams.set("category", value);
        queryParams.set("text", text);
        // Replace current querystring with the new one.
        history.replaceState(null, null, "?"+queryParams.toString());
        history.pushState(null, null, "?"+queryParams.toString());
        url = url + "&text=" + text;
        console.log(url);
        $.ajax({
            url:url,
            type:'GET', 
            success: function(data){
                $('.list-row').html($(data).find('.list-row'));
            }
        });
    }

    blogLoadMore() {
        var _this = this;
        $('.blog-loadmore').on('click', function(){
            var podlimit = $('#podlimit').val();
            var podoffset = $('#podoffset').val();
            var blgcat = $('.category-select').val();
            var text = $('.keyword').val();
            var btn = 'blog-loadmore';
            var url = 'getBlogs';
            _this.loadMore(url, podlimit, podoffset, blgcat, text, btn);
        });
    }

    loadMore(url, podlimit, podoffset, category, text, btn) {
        $.ajax({
            url: '/'+url,
            method: 'get',
            data: {
                offset: podoffset,
                limit: podlimit,
                category: category,
                text: text
            }
        }).done((data) => {
            let blogs = $(data);
            $('.blog-listing > .list-row').append(blogs);
            let count = $('.blog-item').length;
            $('#podoffset').val(parseInt(count));
            if(category.length) {
                var total = $('#ajaxtotal').val();
            } else {
                total = $('#is_more').val(); 
            }
            if (count == total) {
                $('#has_more').val('no');
                $('.'+btn).css('display', 'none');
            } else {
                $('#has_more').val('yes');
            }
            
        }).always(() => {
            $('#has_more').val('yes');
        })
    }
}

new Blog 
